import { Lozenge } from 'shared/lozenge/Lozenge';
import { tokens } from 'styles/tokens';

type StatusLozengeProps = Readonly<{
    status?: string;
    color: string;
}>;

export function StatusLozenge({ status, color }: StatusLozengeProps) {
    return (
        <div>
            <Lozenge color={tokens.text.onColor} backgroundColor={color}>
                {status?.toUpperCase()}
            </Lozenge>
        </div>
    );
}
